import { Component } from '@angular/core';

@Component({
  selector: 'web-loan-survey-shimmer',
  templateUrl: './loan-survey-shimmer.component.html',
  styleUrls: ['./loan-survey-shimmer.component.scss']
})
export class LoanSurveyShimmerComponent {

}
